export default __webpack_public_path__ + "static/contact-08c82b753755990640d4423fa64a765e.png";